import { getMoney } from '@hlj/hlj-utils'
import { dGet } from '@core/utils'
import React from 'react'
import Attachments from '@common/Attachments'
import { Flex } from 'hljd'
import { STATUS_COLOR } from '@components/JiaMeng/NewCustomer/constant'
import style from './style.module.less'

export default [
  {
    dataIndex: 'money',
    title: '服务费金额',
    render: (o, { money, status_name, status, refund_status }) => {
      const color = STATUS_COLOR(status, refund_status)

      return (
        <Flex sp>
          <div>{getMoney(money)}</div>
          <span style={{ color }}>状态：{status_name}</span>
        </Flex>
      )
    }
  },
  {
    dataIndex: 'remark',
    title: '费用备注',
    render: (o, { remark, attachments }) => {
      return (
        <div>
          <div>{remark}</div>
          <Attachments showUpload={false} value={attachments} />
        </div>
      )
    }
  },
  {
    dataIndex: 'inner_remark',
    title: '内部备注'
  },
  {
    dataIndex: 'refund_remark',
    title: '退款原因',
    hidden: refund_remark => {
      return !refund_remark
    },
    className: style.refundRemark,
    render: (o, { refund_remark, refund_attachments }) => {
      return (
        <div>
          <div>{refund_remark}</div>
          <Attachments showUpload={false} value={refund_attachments} />
        </div>
      )
    }
  },
  {
    dataIndex: 'nick',
    title: '申请人',
    render: (o, { refund_merchant_support, merchant_support }) => {
      return refund_merchant_support && refund_merchant_support.nick
        ? dGet(refund_merchant_support, 'nick')
        : dGet(merchant_support, 'nick')
    }
  },
  {
    dataIndex: 'created_at',
    title: '申请时间'
  }
]
